import React, { useState } from 'react';
import Modal from '../Modal';

const PopUp = ({ linkText, modalText }) => {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <>
            <div className="pop-up">
                <p className="pop-up-trigger" onClick={() => setIsOpen(!isOpen)}>
                    {linkText}
                </p>
            </div>
            <Modal isOpen={isOpen} setIsOpen={() => setIsOpen(!isOpen)} modalText={modalText} />
        </>
    );
};

export default PopUp;
